import { ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { BookingModal } from "./BookingModal";
import { Button } from "./ui/button";
import { CalendarDays } from "lucide-react";

export const Layout = ({ children }: { children: ReactNode }) => {
  return (
    <div className="flex min-h-screen flex-col bg-slate-50 relative">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      
      <div className="fixed bottom-6 right-6 z-50 md:bottom-8 md:right-8">
        <BookingModal>
          <Button size="lg" className="rounded-full shadow-xl shadow-primary/30 h-14 px-6 text-base md:text-lg hover:scale-105 transition-transform">
            <CalendarDays className="mr-2 h-5 w-5" />
            Book Now
          </Button>
        </BookingModal>
      </div>

    </div>
  );
};
